import { IAuthServiceV2 } from '@volkswagen-onehub/authservice';
import { ContractsOverview } from './types';

export class ContractCenterService {

    private readonly resourceHostId: string;

    constructor(private readonly authService: IAuthServiceV2, stage: string) {
        this.resourceHostId = `cwat-contract-center-service-${stage}`
    };

    public async getContracts(): Promise<ContractsOverview> {
        const url = 'user/vehicles/overview';

        const response = await this.authService.get(this.resourceHostId, url);

        if (!response.ok) {
            throw new Error(`Request failed with status code ${response.status}`);
        }

        return await response.json() as ContractsOverview;
    }
}